const initState = {
  isLoading: false,
  staffData: [],
  getAllStaffLoading: false,
  updateLoading: false,
  isUpdateLoading: false,
  deleteLoading: false,
  staffRestData: null,
  tablesData: {}
};
const staffReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_ALL_STAFF":
      return {
        ...state,
        staffData: action.payload
      };
    case "GET_ALL_STAFF_LOADER":
      return {
        ...state,
        getAllStaffLoader: action.payload
      };
    case "STAFF_DETAILS":
      return {
        ...state,
        staffRestData: action.payload
      };
    case "STAFF_DELETE_LOADER":
      return {
        ...state,
        deleteLoading: action.payload
      };
    case "STAFF_UPDATE_LOADER":
      return {
        ...state,
        updateLoading: action.payload
      };
    case "STAFF_DELETED":
      return {
        ...state,
        staffData: state.staffData?.filter(
          (staff) => staff.id !== action.payload
        )
      };
    case "STAFF_UPDATED": {
      return {
        ...state,
        staffData: state.staffData.map((staff) =>
          staff.id === action.payload.id
            ? {
                ...staff,
                ...action.payload.obj,
                permissions: action.payload.permissions || staff.permissions
              }
            : staff
        )
      };
    }

    case "ADD_TABLES_LOADING":
      return {
        ...state,
        isLoading: action.payload
      };
    case "OCCUPIED_CHANGE_LOADING":
      return {
        ...state,
        isUpdateLoading: {
          ...state.isUpdateLoading,
          [action.payload.tableId]: action.payload.loading
        }
      };

    case "ADD_TABLES_SUCCESS":
      return {
        ...state,
        tablesData: {
          ...state.tablesData,
          [action.payload.restaurantID]: {
            ...(state.tablesData?.[action.payload.restaurantID] || {}),
            ...action.payload.tables
          }
        }
      };

    case "FETCH_TABLES_LOADING":
      return {
        ...state,
        isLoading: action.payload
      };
    case "FETCH_TABLES_SUCCESS":
      return {
        ...state,
        tablesData: {
          ...state.tablesData,
          info: {
            ...action.payload.infoData
          },
          tables: {
            ...action.payload.tables
          }
        }
      };

    case "STAFF_ADDED":
      return {
        ...state,
        staffData: [action.payload, ...state.staffData]
      };
    default:
      return {
        ...state
      };
  }
};
export default staffReducer;
